import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { PathwayVisibilityComponent } from '@app/pathways/components/settings/pathway-visibility/pathway-visibility.component';
import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { PathwayModule } from '@app/pathways/components/pathway/pathway.module';
import { MarkdownModule } from '@app/markdown/markdown.module';
import { LayoutModule } from '@app/layout/layout.module';
import { PathwayFollowersModule } from '@app/pathways/components/pathway-followers/pathway-followers.module';
import { PathwayRoutingModule } from '@app/pathways/routes/pathway-routing.module';
import { NavigationModule } from '@app/navigation/navigation.module';
import { InputsSharedModule } from '@app/inputs/inputs-shared.module';

import { ReactivePageDeclarations } from '.';

import { PathwayPageComponent } from './pathway-page/pathway-page.component';
import { ContentCatalogSharedModule } from '@app/content-catalog/content-catalog-shared.module';

/**
 * NOTE: This module is lazyloaded, do not import it directly into another component
 *
 * If you need to use components/services that are specific to this module, move
 * them out into the `pathway-shared.module` and import that that module into your
 * module instead.
 *
 * You might need to create `pathway-shared.module` if it does not exist yet.
 */
@NgModule({
  declarations: [
    PathwayVisibilityComponent,
    ...ReactivePageDeclarations, // Pathway Version 2 Page components using ReactiveStores
    PathwayPageComponent,
  ],
  exports: [],
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    ContentCatalogSharedModule,
    GroupsSharedModule,
    InputsSharedModule,
    MarkdownModule,
    NavigationModule,
    PathwayRoutingModule,
    PathwayModule,
    PathwayFollowersModule, // TODO: lazy load this after LaunchDarkly.PATHWAY_ROUTER is gone
  ],
  providers: [],
})
export class PathwayPageModule {}
